import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const downloadCenter: ThemeApp['appComponents']['downloadCenter'] = {
  downloadCenter: {
    linksContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary900
    }
  },

  components: {
    downloadCard: {
      container: {
        rlecBackgroundColor: themeUi.semantic.color.background.primary600,
        notRlecBackgroundColor: themeUi.semantic.color.background.primary500,
        color: themeUi.semantic.color.text.secondary900
      },
      selectTrigger: {
        borderColor: themeUi.semantic.color.border.primary300,
        color: themeUi.semantic.color.text.secondary900,
        fill: themeUi.semantic.color.icon.secondary900
      },
      styledButton: {
        color: themeUi.semantic.color.text.secondary900
      }
    },

    links: {
      color: themeUi.semantic.color.text.secondary50
    }
  }
};
